import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify'
import { MappingApi, MappingApiImpl } from './apis/mapping-api'

export const mappingContainer = new ContainerModule((bind) => {
    bind(MappingApi).to(MappingApiImpl)
})
